import type { TranscriptionResponseDTO } from '@klangio/ai2notes-ts-client';
import { Container } from '@mui/material';
import { useTranslation } from 'react-i18next';
import * as React from 'react';
import { TranscriptionProgress } from '../../components/molecules';

export const DELAY_RATING_MODAL_TIME_IN_MS = 20 * 1000;

interface FileProps {
  transcription?: TranscriptionResponseDTO;
  processingTime: number;
  message: string;
  estimatedDuration: number;
  progress: any;
}

const FileProgress: React.FC<FileProps> = ({
  transcription,
  message,
  progress,
  estimatedDuration,
  processingTime,
}) => {
  const { t } = useTranslation();

  return (
    <Container
      id="container-progress"
      maxWidth="md"
      style={{ minHeight: 'calc(100vh - 420px)', margin: 'auto auto' }}
    >
      <TranscriptionProgress
        title={t('home.input.transcribing', {
          title: transcription.title,
        })}
        message={message}
        progress={progress}
        estimatedDuration={estimatedDuration}
        estimatedText={t('home.input.estimated')}
        processingTime={processingTime}
      />
    </Container>
  );
};

export default FileProgress;
